<template>
    <div class="container">
        <div class="row">
            <div class="col-md-12">

                <div class="col-12 mt-4 mb-4 gifted-voucher">
                    <div class="card">
                        <div class="card-header">
                            <div class="row">
                                <div class="col-md-6">
                                    <img class="img-fluid" v-bind:src="'/img/' + this.logo"  width="150" alt="Gifted PH" title="Gifted PH" />
                                </div>
                            </div>
                        </div>
                        <div class="card card-title text-center">
                            <h3>
                                GCash Redemption Page
                            </h3>

                        </div>
                        <div class="row p-3">
                            <div class="col-md-12">
                                <div class="card mb-2">
                                    <div class="card-body">
                                        <p class="font-italic">Please fill out this form to complete your enrollment into the Gcash Business Disbursement Tool.</p>
                                        <ul class="text-justify">
                                            <li><b> For Existing Gcash Users:</b> For smoother approvals, please make sure to indicate the exact details found in your Gcash account. The more specific the better (example: please indicate the house #/Bldg.#/Room# along with your complete street name in column K</li>
                                            <li><b> For New Gcash Users:</b> You will be required to validate your new account via the Gcash mobile app after registration</li>
                                        </ul>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-body">
                                        <form id="gcashForm">
                                            <div class="form-row">
                                                <div class="form-group col-md-6">
                                                    <label for="voucher_code">Gifted Voucher Code</label>
                                                    <div class="input-group mb-3">
                                                        <input type="text" class="form-control" id="voucher_code" name="voucher_code" placeholder="Gifted Voucher Code" v-model="voucher_code">
                                                        <div class="input-group-append">
                                                            <button class="btn btn-outline-secondary" @click="verify()" type="button">Verify</button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="form-group col-md-6">
                                                    <label for="voucher_code">Amount</label>
                                                    <input type="text" class="form-control" id="voucher_amount" name="voucher_amount" readonly />
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="form-group col-md-6">
                                                    <label for="">Mobile Number</label>
                                                    <input type="text" class="form-control" id="mobile_number" name="mobile_number" placeholder="GCash Mobile Number" />
                                                    <small>Start your number from 09 and must be 11 digits.</small>
                                                </div>
                                                <div class="form-group col-md-6">
                                                    <label for="">GCash Registered Email Address</label>
                                                    <input type="email" class="form-control" id="email_address" name="email_address" placeholder="Email Address" />
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="form-group col-md-4">
                                                    <label for="">Last Name</label>
                                                    <input type="text" class="form-control" id="last_name" name="last_name" placeholder="Last Name" />
                                                </div>
                                                <div class="form-group col-md-4">
                                                    <label for="">First Name</label>
                                                    <input type="text" class="form-control" id="first_name" name="first_name" placeholder="First Name" />
                                                </div>
                                                <div class="form-group col-md-4">
                                                    <label for="">Middle Name</label>
                                                    <input type="text" class="form-control" id="middle_name" name="middle_name" placeholder="Middle Name" />
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="form-group col-md-6">
                                                    <label for="">Birthdate</label>
                                                    <input type="date" class="form-control" id="birthdate" name="birthdate"  />
                                                </div>
                                                <div class="form-group col-md-6">
                                                    <label for="">Birth Place</label>
                                                    <input type="text" class="form-control" id="birthplace" name="birthplace" placeholder="Birth Place" />
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="form-group col-md-4">
                                                    <label for="">Nationality</label>
                                                    <input type="text" class="form-control" id="nationality" name="nationality" placeholder="Nationality" />
                                                </div>
                                                <div class="form-group col-md-4">
                                                    <label for="">ID Type</label>
                                                    <select name="id_type" id="id_type" class="form-control">
                                                        <option value="">- Select ID Type -</option>
                                                        <option value="Passport">Passport</option>
                                                        <option value="Driver ID License">Driver's License</option>
                                                        <option value="UMID">UMID Card</option>
                                                        <option value="PhilHealth ID">PhilHealth ID</option>
                                                        <option value="TIN Card">TIN Card</option>
                                                        <option value="Postal ID">Postal ID</option>
                                                        <option value="Voter's ID">Voter's ID</option>
                                                        <option value="PRC ID">PRC ID</option>
                                                        <option value="Senior Citizen">Senior Citizen ID</option>
                                                    </select>
                                                </div>
                                                <div class="form-group col-md-4">
                                                    <label for="">ID Number</label>
                                                    <input type="text" class="form-control" id="id_number" name="id_number" placeholder="ID Number" />
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="form-group col-md-4">
                                                    <label for="">House Number</label>
                                                    <input type="text" class="form-control" id="house_number" name="house_number" placeholder="House Number" />
                                                </div>
                                                <div class="form-group col-md-4">
                                                    <label for="">Street Address</label>
                                                    <input type="text" class="form-control" id="street_address" name="street_address" placeholder="Street Address" />
                                                </div>
                                                <div class="form-group col-md-4">
                                                    <label for="">Building Name</label>
                                                    <input type="text" class="form-control" id="building_name" name="building_name" placeholder="Building Name" />
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="form-group col-md-6">
                                                    <label for="">Barangay</label>
                                                    <input type="text" class="form-control" id="barangay" name="barangay" placeholder="Barangay"/>
                                                </div>
                                                <div class="form-group col-md-6">
                                                    <label for="voucher_code">Subdivision</label>
                                                    <input type="text" class="form-control" id="subdivision" name="subdivision" placeholder="Subdivision" />
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="form-group col-md-6">
                                                    <label for="">City</label>
                                                    <input type="text" class="form-control" id="city" name="city" placeholder="City"/>
                                                </div>
                                                <div class="form-group col-md-6">
                                                    <label for="voucher_code">Province</label>
                                                    <input type="text" class="form-control" id="province" name="province" placeholder="Province" />
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="form-group col-md-6">
                                                    <label for="">Country</label>
                                                    <input type="text" class="form-control" id="country" name="country" placeholder="Country"/>
                                                </div>
                                                <div class="form-group col-md-6">
                                                    <label for="voucher_code">Zip Code</label>
                                                    <input type="text" class="form-control" id="zip_code" name="zip_code" placeholder="Zip Code" />
                                                </div>
                                            </div>
                                            <hr>
                                            <div class="form-row">
                                                <div class="form-group col-md-12">
                                                    <input type="checkbox" id="agree" class="mr-2" /> All data is secure and will be processed according to Gifted.PH Data Privacy Standards. I have read the Privacy Policy.
                                                </div>
                                            </div>

                                            <input type="hidden" name="_token" id="token">
                                        </form>

                                        <div class="form-row">
                                            <div class="form-group col-md-12 text-center">
                                                <button type="button" @click="submitUser()" class="btn btn-success btn-lg" id="btn_submit" disabled>Submit</button>
                                            </div>
                                        </div>

                                    </div>
                                </div>

                            </div>
                        </div>
                        <div class="card-footer">
                            <div class="row">
                                 <div class="col-md-12">
                                    <h2>Gifted. The Gift Giving Company</h2>
                                    <p>For more information, visit <a target="_blank" href="https://gifted.ph/">www.gifted.ph</a> or email us at <a href="mailto:admin@gifted.ph">admin@gifted.ph</a></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>
<style scoped>

</style>
<script>
    import axios from 'axios'

    export default {
        props: [],
        data(){
            return {
                voucher_code: "",
                logo: "gifted-logo-voucher.jpg",
            }
        },
        mounted() {

        },
        methods: {
            submitUser: () => {

                if($("#agree").prop("checked")){
                    var voucher_code = $('#voucher_code').val();
                    var voucher_amount = $('#voucher_amount').val();
                    var last_name = $('#last_name').val();
                    var first_name = $('#first_name').val();
                    var middle_name = $('#middle_name').val();
                    var email_address = $('#email_address').val();
                    var mobile_number = $('#mobile_number').val();
                    var birthdate = $('#birthdate').val();
                    var birthplace = $('#birthplace').val();
                    var nationality = $('#nationality').val();
                    var id_type = $('#id_type').val();
                    var id_number = $('#id_number').val();
                    var house_number = $('#house_number').val();
                    var street_address = $('#street_address').val();
                    var building_name = $('#building_name').val();
                    var barangay = $('#barangay').val();
                    var subdivision = $('#subdivision').val();
                    var city = $('#city').val();
                    var province = $('#province').val();
                    var country = $('#country').val();
                    var zip_code = $('#zip_code').val();

                    if(voucher_code == '' || voucher_amount == '' || last_name == '' || first_name == '' || middle_name == '' || email_address == '' || mobile_number == '' || birthdate == '' || birthplace == '' || nationality == '' || id_type == '' || id_number == '' || house_number == '' || street_address == '' || building_name == '' || barangay == '' || subdivision == '' || city == '' || province == '' || country == '' || zip_code == '' ){
                        Swal.fire({
                            icon: 'error',
                            title: 'Please fill up all required fields.'
                        })
                    }
                    else{
                        var regex = /^09[0-9]{9}$/;
                        console.log(String(mobile_number));
                        if(regex.test(String(mobile_number)))
                        {
                            var token = $('meta[name="csrf-token"]').attr('content');
                            $('#token').val(token);
                            var formData = $('#gcashForm').serialize();
                            $.ajax({
                                type:'POST',
                                url:'/gcash/submit',
                                data: formData,
                                success: (result) => {
                                if(result)
                                {
                                    Swal.fire({
                                            icon: 'success',
                                            title: 'Thank you for your submission!',
                                            text: 'The process could take up to 7 working days depending on Gcash approval based on accuracy of data provided.  Please contact us at admin@gifted.ph for any questions',
                                            allowEscapeKey : false,
                                            allowOutsideClick: false,
                                        }).then((result) => {
                                            if (result.isConfirmed) {
                                                window.location.reload();
                                            }
                                        })
                                }
                                },
                                beforeSend: () => {
                                    Swal.fire({
                                        title: 'Verifying...',
                                        html: '<div class="spinner-grow" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
                                        showConfirmButton: false,
                                        allowEscapeKey : false,
                                        allowOutsideClick: false,
                                    });
                                }
                            });
                        }
                        else
                        {
                            Swal.fire({
                                icon: 'error',
                                title: 'Mobile number must start in 09 and should be 11 digits.'
                            })
                        }
                    }



                }
                else{
                    Swal.fire({
                        icon: 'info',
                        title: 'Did you read and agree the Privacy Policy?'
                    })
                }
            },
            verify: () => {
                var voucher_code = $('#voucher_code').val();
                var token = $('meta[name="csrf-token"]').attr('content');

                if(voucher_code)
                {

                    $.ajax({
                        type:'POST',
                        url:'/gcash/verify',
                        data: {
                            _token: $('meta[name="csrf-token"]').attr('content'),
                            voucher_code: voucher_code,
                        },
                        success: (result) => {
                            if(result == 'Invalid Voucher Code'){
                                 Swal.fire({
                                    icon: 'error',
                                    title: 'Invalid Voucher Code'
                                })
                                $('#voucher_code').val('')
                                $('#voucher_amount').val('')
                                 $('#btn_submit').prop("disabled", true);
                            }
                            else if((result) == 'used'){
                                Swal.fire({
                                    icon: 'error',
                                    title: 'Voucher Code is already Redeemed.'
                                })
                                $('#voucher_code').val('')
                                $('#voucher_amount').val('')
                                $('#btn_submit').prop("disabled", true);
                            }
                            else{
                                $('#btn_submit').prop("disabled", false);
                                $('#voucher_amount').val(result)
                                Swal.close();
                            }
                        },
                        beforeSend: () => {
                            Swal.fire({
                                title: 'Processing...',
                                html: '<div class="spinner-grow" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
                                showConfirmButton: false,
                                allowEscapeKey : false,
                                allowOutsideClick: false,
                            });
                        }
                    });
                }
                else{
                    Swal.fire({
                        icon: 'error',
                        title: 'Voucher Code is required'
                    })
                }
            }
        }
    }



</script>
